<template>
  <div></div>
</template>

<script>
import axios from "axios";
export default {
  computed: {
    base() {
      return this.$store.getters.paytm_pg;
    },
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    notification(type, message) {
      this.$notify({
        group: "foo",
        title: "Important message",
        text: message,
        duration: 5000,
        type: type,
      });
    },
  },
  async mounted() {
    const vm = this;
    let { query } = vm.$route;
    let { transaction_id } = query;
    let { base, user } = vm;
    let { phone, password, authkey } = user;
    let url = `${base}/Log?MobileNo=${phone}&Password=${password}&TransId=${transaction_id}&Response=&AuthKey=${authkey}&Source=JSON`;
    vm.$root.loader = true;
    try {
      let { data } = await axios(url);
      console.log(data);
      vm.$router.push("/");
      vm.$root.loader = false;
    } catch (err) {
      vm.$root.loader = false;
      vm.notification("error", err.message);
    }
  },
};
</script>

<style>
</style>